<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Promotion Information</div>
      </div>
      <v-spacer></v-spacer>
      <div slot="action">
        <v-tooltip top>
          <v-btn slot="activator" icon @click="exportPromotionSummary" :loading="exportPromotionSummaryLoading">
            <v-icon color="secondary">mdi-printer</v-icon>
          </v-btn>
          <span>Export Promotion Summary</span>
        </v-tooltip>
        <v-tooltip top>
          <v-btn slot="activator" icon @click="doReview">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <span>Edit Promotion</span>
        </v-tooltip>
      </div>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.promotion}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{promotionForm.promotion}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.description}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div>{{promotionForm.description}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.effDate}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div>{{formatDateTime2(promotionForm.effDate)}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.endDate}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div>{{formatDateTime2(promotionForm.endDate)}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.enabledB2C}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div>{{formatBoolean(promotionForm.enabledB2C)}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.enabledB2B}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div>{{formatBoolean(promotionForm.enabledB2B)}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.stdPromo}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div>{{formatBoolean(promotionForm.stdPromo)}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.usrGrpPromo}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div>{{formatBoolean(promotionForm.usrGrpPromo)}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.cardPromo}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div>{{formatBoolean(promotionForm.cardPromo)}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.couponPromo}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div>{{formatBoolean(promotionForm.couponPromo)}}</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import { formatDisplayDateTime2 } from '@/utils/date'
import FieldMixin from '@/mixins/field'

export default {
  data() {
    return {
      labels: {
        promotion: 'Promotion',
        description: 'Promotion Description',
        effDate: 'Effective Date',
        endDate: 'Expiry Date',
        enabledB2C: 'Enabled for B2C',
        enabledB2B: 'Enabled for B2B',
        stdPromo: 'Standard Promotion',
        usrGrpPromo: 'User Group Promotion',
        cardPromo: 'Credit Card Promotion',
        couponPromo: 'Coupon Promotion'
      },
      promotionForm: {
        campaign: undefined,
        description: undefined,
        effDate: undefined,
        endDate: undefined,
        enabledB2C: undefined,
        enabledB2B: undefined,
        stdPromo: undefined,
        usrGrpPromo: undefined,
        cardPromo: undefined,
        couponPromo: undefined
      },
      menu: [],
      exportPromotionSummaryLoading: false
    }
  },
  methods: {
    async doInit() {
      await this.queryPromotion()
    },
    async queryPromotion() {
      const apiURI = this.$store.state.promotionManagement.menu.promotionGet
      if (apiURI) {
        try {
          const expand = {
            promotion: this.promotion
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            // Promotion init
            this.promotionForm.promotion = data.promotion.promotion
            this.promotionForm.description = data.promotion.description
            this.promotionForm.effDate = data.promotion.effDate
            this.promotionForm.endDate = data.promotion.endDate
            this.promotionForm.enabledB2C = data.promotion.enabledB2C
            this.promotionForm.enabledB2B = data.promotion.enabledB2B
            this.promotionForm.stdPromo = data.promotion.stdPromo
            this.promotionForm.usrGrpPromo = data.promotion.usrGrpPromo
            this.promotionForm.cardPromo = data.promotion.cardPromo
            this.promotionForm.couponPromo = data.promotion.couponPromo
            this.promotionForm.revision = data.promotion.revision

            // Extract menu
            this.menu = extractMenu(result.data._links)
          }
        } catch (error) {
          throw error
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doReview() {
      this.$router.push({ name: 'promotionReview', params: { promotion: this.promotion } })
    },
    async exportPromotionSummary() {
      const apiUrl = this.menu.exportPromotionSummary
      if (apiUrl) {
        try {
          this.exportPromotionSummaryLoading = true
          const passObj = {
            promotion: this.promotion
          }
          await this.$http.post(apiUrl, passObj)
          this.exportPromotionSummaryLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.exportPromotionSummaryLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    formatDateTime2(dateTime) {
      return formatDisplayDateTime2(dateTime)
    }
  },
  props: {
    promotion: {
      type: String,
      default: ''
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    FieldMixin
  ]
}
</script>

<style lang="scss">
</style>
